module.exports = __webpack_public_path__ + "static/ISO-9001-47806c6d385624b4a08aab396e552e74.png";